import "./App.css";
import React from "react";
import { Route, Switch } from "react-router-dom";
import VideoPageView from "./components/VideoPageView";
import LandingPage from "./components/LandingPage";


export const config = {
  endpoint: `https://43797704-d00d-4f40-a564-c7852c16ab8d.mock.pstmn.io/v1`
};

function App(){
  return (
    <div className="App">
     
      <React.StrictMode>
       <Switch>
            <Route exact path ="/" component={LandingPage} />
            <Route path="/video/:id" component={VideoPageView} /> 
      </Switch>
    </React.StrictMode>
    </div>
  );
};

export default App;
